/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import { defineMessages } from 'react-intl'

export default defineMessages({
  clusterId: {
    id: 'ccm.clusters-table.table.header.id',
    defaultMessage: 'Cluster ID',
  },
  services: {
    id: 'ccm.clusters-table.table.header.services',
    defaultMessage: 'Services',
  },
  disconnectCluster: {
    id: 'ccm.clusters-table.table.action.disconnect-cluster',
    defaultMessage: 'Disconnect cluster',
  },
  disconnectClusterDescription: {
    id: 'ccm.clusters-table.table.action.disconnect-cluster.description',
    defaultMessage: 'Disconnect this cluster from Elastic Cloud Connected Services',
  },
  actions: {
    id: 'ccm.clusters-table.table.header.actions',
    defaultMessage: 'Actions',
  },
  actionsAriaLabel: {
    id: 'ccm.clusters-table.table.header.actions.aria-label',
    defaultMessage: 'All actions for cluster {clusterName}',
  },
  disconnectModalTitle: {
    id: 'ccm.clusters-table.disconnect-cluster.modal.title',
    defaultMessage: 'Disconnect cluster',
  },
  nameToConfirmFormRowLabel: {
    id: 'ccm.clusters-table.disconnect-cluster.modal.name-to-confirm',
    defaultMessage: 'Type the cluster name to confirm',
  },
  modalCancelButton: {
    id: 'ccm.clusters-table.disconnect-cluster.modal.cancel',
    defaultMessage: 'Cancel',
  },
  noClusters: {
    id: 'ccm.clusters-table.table.no-clusters',
    defaultMessage: 'No clusters found',
  },
  deleteButtonLabel: {
    id: 'ccm.clusters-table.disconnect-cluster.modal.disconnect',
    defaultMessage: 'Disconnect cluster',
  },
  mistypedResourceNameError: {
    id: 'ccm.clusters-table.disconnect-cluster.modal.error',
    defaultMessage: 'The deployment name you typed does not match {name}',
  },
  modalCalloutTitle: {
    id: 'ccm.clusters-table.disconnect-cluster.modal.callout.title',
    defaultMessage: 'Disconnecting a cluster cannot be reversed',
  },
  modalCalloutMessage: {
    id: 'ccm.clusters-table.disconnect-cluster.modal.callout',
    defaultMessage:
      'This action cannot be undone and permanently deletes connection with the cluster {name}. If you ' +
      'proceed, your existing connected services will be disabled and you will lose any data within them.',
  },
  copyToClipboardMessage: {
    id: 'ccm.clusters-table.disconnect-cluster.modal.copy-to-clipboard',
    defaultMessage: 'Copy cluster name to clipboard',
  },
  successfullyCopiedToClipboard: {
    id: 'ccm.clusters-table.disconnect-cluster.modal.license-id-copied-to-clipboard',
    defaultMessage: 'Copied to clipboard successfully',
  },
  loadingClusters: {
    id: 'ccm.clusters-table.loading-clusters',
    defaultMessage: 'Loading clusters...',
  },
  organizationId: {
    id: 'ccm.clusters-table.table.header.organization-id',
    defaultMessage: 'Organization ID',
  },
  connectedAt: {
    id: 'ccm.clusters-table.table.header.connected-at',
    defaultMessage: 'Connected at',
  },
  connectedBy: {
    id: 'ccm.clusters-table.table.header.connected-by',
    defaultMessage: 'Connected by',
  },
  license: {
    id: 'ccm.clusters-table.table.header.license',
    defaultMessage: 'License',
  },
  copyLicenseId: {
    id: 'ccm.clusters-table.table.action.copy-license-id',
    defaultMessage: 'Copy License ID',
  },
  viewOrganization: {
    id: 'ccm.clusters-table.table.action.view-organization',
    defaultMessage: 'View organization',
  },
  searchByOrganizationId: {
    id: 'ccm.clusters-table.table.action.search-by-organization-id',
    defaultMessage: 'Search by Organization ID',
  },
  searchByClusterId: {
    id: 'ccm.clusters-table.table.action.search-by-cluster-id',
    defaultMessage: 'Search by Cluster ID',
  },
  searchByLicenseId: {
    id: 'ccm.clusters-table.table.action.search-by-license-id',
    defaultMessage: 'Search by License ID',
  },
  includeDisconnectedClusters: {
    id: 'ccm.clusters-table.table.action.include-disconnected-clusters',
    defaultMessage: 'Include Disconnected Clusters',
  },
  includeInternalUsers: {
    id: 'ccm.clusters-table.table.action.include-internal-users',
    defaultMessage: 'Include Internal Users',
  },
})
